import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getUsers(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/users/500/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function createUser(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/users`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}

export async function deleteUser(accessToken, id) {
  const result = await axios({
    method: "DELETE",
    url: `${BASE_API_URL}/users/${id}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result;
}

export async function getUserById(accessToken, id) {
  try {
    const result = await axios.get(`${BASE_API_URL}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return result.data;
  } catch (error) {
    return error.response;
  }
}

export async function editUser(accessToken, data) {
  try {
    const result = await axios(`${BASE_API_URL}/users`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    });

    return result;
  } catch (error) {
    return error.response;
  }
}
